import 'perfect-scrollbar/css/perfect-scrollbar.css';
import React, { useEffect, useState } from 'react';
import useAxios from '../../helpers/useAxios';
import FraudGraph from '../../components/NetworkGraph/NetworkGraph';
import { GraphData, transformData } from '../../helpers/transformData';

const Graph: React.FC = () => {
    console.log('Graph component rendering');

    const [graphData, setGraphData] = useState<GraphData>({
        nodes: [],
        links: []
    });

    // Set up the useAxios hook

    const [{ data, loading, error }, execute] = useAxios({ url: `/dashboard/organization/graph` }, { manual: true });
    console.log('useAxios state:', { hasData: !!data, loading, hasError: !!error });
    // Fetch data when the component mounts
    useEffect(() => {
        console.log('Executing API request');
        execute()
            .then(() => console.log('API request completed'))
            .catch((err) => console.error('API request failed:', err));
    }, [execute]);

    // Transform data when it arrives
    useEffect(() => {
        console.log('Data effect triggered:', { hasData: !!data });

        if (data) {
            console.log('Raw API response:', data);

            try {
                const transformedData = transformData(data);
                console.log('Transformed data:', {
                    nodeCount: transformedData.nodes.length,
                    linkCount: transformedData.links.length
                });

                setGraphData(transformedData);
            } catch (err) {
                console.error('Error transforming data:', err);
            }
        }
    }, [data]);

    // Handle loading state
    if (loading) {
        console.log('Rendering loading state');
        return <div>Loading...</div>;
    }

    // Handle error state
    if (error) {
        console.error('Rendering error state:', error);
        return <div>Error loading graph data: {error.message}</div>;
    }

    console.log('Rendering graph with data:', {
        nodeCount: graphData.nodes.length,
        linkCount: graphData.links.length
    });

    return (
        <div style={{ height: '100%', width: '100%' }}>
            <FraudGraph graphData={graphData} />
        </div>
    );
};

export default Graph;
